export const quizNames = {
    sixieme: {
        francaisVocabulaire2023: "Français - Vocabulaire",
        mathsAutomatismes2023: "Mathématiques - Automatismes",
        mathsProblemes2023: "Mathématiques - Résolution de problèmes"
    },
    quatrieme: {
        mathsAutomatismes2023: "Mathématiques - Automatismes",
        mathsProblemes2023: "Mathématiques - Résolution de problèmes",
        francaisComprehension2023: "Français - Compréhension de l'écrit",
        francaisLexique2023: "Français - Lexique"
    },
	seconde: {
        mathsAutomatismes2023: "Mathématiques - Automatismes",
		francaisComprehension12023: "Français - Compréhension de l'écrit - Les robots",
		francaisComprehension22023: "Français - Compréhension de l'écrit - L'île des esclaves"
    }
};

export const questionsData = {
    sixieme:{
        mathsProblemes2023: [
          {
            question: "Lors de son anniversaire, Robin achète 15 bouteilles de jus de fruits de 0,33 L chacune. Une bouteille coûte 0,76 €. Un des calculs ci-dessous permet de trouver le nombre total de litres de jus de fruits. Lequel ?",
            options: [
              "15 + 0,33 + 0,76",
              "15 x 0,33",
              "15 x 0,33 x 0,76",
              "15 x 0,76"
            ],
            correctAnswer: 1
          },
          {
            question: "À la boulangerie, Kim a acheté 3 croissants à 1,20 € l’un et un pain aux raisins à 2 €. Elle donne 10 €. Combien va-t-on lui rendre ?",
            options: [
              "5,60 €",
              "4,40 €",
              "3,20 €",
              "6,80 €"
            ],
            correctAnswer: 1
          },
          {
            question: "Dans la même boulangerie :<br/>• 3 pains au chocolat coûtent 4,20€.<br/>• 2 pains au chocolat coûtent 2,80€.<br/>Parmi les opérations suivantes, une seule permet de trouver le prix de 5 pains au chocolat. Laquelle ?",
            options: [
              "4,20 € + 2 €",
              "4,20 € x 2,80 €",
              "4,20 € + 2,80 €",
              "4,20 € x 2 €"
            ],
            correctAnswer: 2
          },
          {
            question: "Je choisis un nombre.<br/>Si j’augmente ce nombre de 5, j’obtiens la moitié de 1000.<br/>Quel nombre ai-je choisi au départ ?",
            options: [
              "505",
              "495",
              "1005",
              "995"
            ],
            correctAnswer: 1
          },
          {
            question: "Dans une recette, pour faire un gâteau au chocolat pour 8 personnes, il faut 4 œufs.<br/>Combien dois-je prévoir d’œufs pour 24 personnes ?",
            options: [
              "12",
              "24",
              "28",
              "32"
            ],
            correctAnswer: 0
          },
          {
            question: "Dans sa commode, Kevin a 5 écharpes différentes et 3 paires de gants différentes.<br/>Combien d’assortiments différents peut-il réaliser ?",
            options: [
              "15",
              "8",
              "2",
              "10"
            ],
            correctAnswer: 0
          },
          {
            question: "Matthieu a trois fois moins de jeux vidéo que Julie. Matthieu a 12 jeux vidéo.<br/>Combien de jeux a Julie ?",
            options: [
              "15",
              "36",
              "4",
              "9"
            ],
            correctAnswer: 1
          },
          {
            question: "Une douche représente en moyenne 80 L d’eau et un bain 200 L d’eau. Si Joseph prend une douche par jour au lieu d’un bain, quelle sera l’économie d’eau réalisée à la fin d’une semaine ?",
            options: [
              "280 L",
              "840 L",
              "1 400 L",
              "1960 L"
            ],
            correctAnswer: 1
          },
          {
            question: "Marie a constaté qu’il faut un litre de lait pour remplir complètement quatre verres identiques. Quelle est la contenance d’un verre (en centilitre) ?",
            options: [
              "0,25 cL",
              "25 cL",
              "4 cL",
              "0,04 L"
            ],
            correctAnswer: 1
          },
          {
            question: `<table align="center" border="1" cellspacing="0" cellpadding="5"><tr><th>Jours</th><th>Matin</th><th>Coef.</th><th>Soir</th><th>Coef.</th></tr><tr><td>V 22 juin</td><td>01h27</td><td>58</td><td>14h03</td><td>58</td></tr><tr><td>S 23 juin</td><td>02h25</td><td>58</td><td>14h55</td><td>59</td></tr><tr><td>D 24 juin</td><td>03h17</td><td>61</td><td>15h42</td><td>64</td></tr><tr><td>L 25 juin</td><td>04h02</td><td>66</td><td>16h22</td><td>68</td></tr><tr><td>M 26 juin</td><td>04h38</td><td>71</td><td>16h52</td><td>73</td></tr></table><br/><br/>Ce tableau indique les horaires de marée haute pour La Rochelle. Le temps écoulé entre les deux pleines mers dans la journée du lundi 25 juin est de...`,
            options: [
              "12 heures et 20 minutes",
              "20 heures et 24 minutes",
              "11 heures et 40 minutes",
              "20 heures et 20 minutes"
            ],
            correctAnswer: 0
          },
          {
            question: "Sur une carte, 1 cm représente 4 km dans la réalité.<br/>Trouver la distance dans la réalité d’un segment de 10 cm sur le plan.",
            options: [
              "0,4 km",
              "4 km",
              "40 km",
              "400 km"
            ],
            correctAnswer: 2
          },
          {
            question: "Une voiture roule à vitesse constante. Elle parcourt 80 km en une heure.<br/>Quelle distance parcourt-elle en un quart d’heure ?",
            options: [
              "20 km",
              "40 km",
              "60 km",
              "80 km"
            ],
            correctAnswer: 0
          },
          {
            question: "Un rectangle a un périmètre de 500 m. Sa longueur mesure 150 m.<br/>Combien mesure sa largeur ?",
            options: [
              "100 m",
              "350 m",
              "200 m",
              "125 m"
            ],
            correctAnswer: 0
          },
          {
            question: `Observer les figures ci-dessous.<br/><img src="./figures.png" alt=""><br/>`,
            options: [
              "L’aire de la figure A est plus grande que celle de la figure B.",
              "L’aire de la figure A est plus petite que celle de la figure B.",
              "L’aire de la figure A est la même que celle de la figure B.",
              "On ne peut pas savoir quelle est la plus grande aire car les deux figures ne sont pas superposables."
            ],
            correctAnswer: 1
          },
          {
            question: `Observer les figures ci-dessous.<br/>On a représenté une image et sa réduction à l’échelle 1/5.<br/>L’image originale a la forme d’un rectangle de longueur 20 cm et de largeur 15 cm.<br/>Quelles sont les dimensions de sa réduction ?<br/><img src="./reduction.png" alt=""><br/>`,
            options: [
              "Longueur : 4 cm - Largeur : 3 cm",
              "Longueur : 15 cm - Largeur : 10 cm",
              "Longueur : 25 cm - Largeur : 20 cm",
              "Longueur : 100 cm - Largeur : 75 cm"
            ],
            correctAnswer: 0
          }
        ],
        mathsAutomatismes2023: [
		    {
            question: "Le nombre soixante-seize-mille-quatre s’écrit :",
            options: [
              "76 004",
              "76 1004",
              "60 16 1004",
              "16 004"
            ],
            correctAnswer: 0
          },
          {
            question: `3 + <span class="stacked-fraction"><div class="numerator">2</div><div class="denominator">10</div></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;=  ...`,
            options: ["0,32", "3,2", "32,0", "32,10"],
            correctAnswer: 1,
          },        
          {
            question: "5 centièmes est égal à ...",
            options: ["10 fois 5 dixièmes", "10 fois 5 millièmes.", " 10 fois 5 unités.", "10 fois 5 dizaines."],
            correctAnswer: 1
          },          
          {
            question: "Quel est le plus petit nombre parmi les suivants",
            options: ["1,082", "1,4", "1,09", "2,03"],
            correctAnswer: 0,
          },
          {
            question: "La moitié de 8,10 est ...",
            options: ["4,20", "4,50", "4,05", "4,5"],
            correctAnswer: 2,
          },
          {
            question: "Quel est le nombre qui complète cette égalité ? 900 000 + 80 000 + 40 + 1 = ...",
            options: ["98 041", "980 041", "9 800 041", "9 841"],
            correctAnswer: 1,
          },
          {
            question: "Quel nombre correspond à soixante-douze millièmes ?",
            options: ["0,720", "72,001", "72,1000", "0,072"],
            correctAnswer: 3,
          },
          {
            question: `Quel nombre est égal à 6 + <span class="stacked-fraction"><div class="numerator">8</div><div class="denominator">10</div></span> + <span class="stacked-fraction"><div class="numerator">5</div><div class="denominator">1000</div></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;?`,
            options: ["6,85", "6,805", "685", "68,5"],
            correctAnswer: 1,
          },
          {
            question: `Quel nombre est égal à la fraction <span class="stacked-fraction"><div class="numerator">4</div><div class="denominator">100</div></span>&nbsp;&nbsp;&nbsp;?`,
            options: ["0,04", "0,4", "4", "400"],
            correctAnswer: 0,
          },
          {
            question: "Voici un nombre : 2 unités et 54 dixièmes.<br/>Parmi les quatre propositions, quelle est l’autre écriture de ce nombre ?",
            options: ["2,54", "7,4", "254", "542"],
            correctAnswer: 1
          },
          {
            question: `Parmi les propositions suivantes, cliquer sur la fraction égale à <span class="stacked-fraction"><div class="numerator">1</div><div class="denominator">2</div></span> .`,
            options: [`<span class="stacked-fraction"><div class="numerator">5</div><div class="denominator">10</div></span>`, `<span class="stacked-fraction"><div class="numerator">10</div><div class="denominator">10</div></span>`, `<span class="stacked-fraction"><div class="numerator">4</div><div class="denominator">2</div></span>`, `<span class="stacked-fraction"><div class="numerator">10</div><div class="denominator">2</div></span>`],
            correctAnswer: 0
          },
          {
            question: `Quel grand nombre faut-il placer dans le cadre vide sur cette droite graduée ?<br/><img src="./droite.png" alt=""><br/>`,
            options: ["2 600 000", "2 060 000", "2 000 600", "2 000 006"],
            correctAnswer: 0
          },
          {
            question: `Observer cette demi-droite graduée.<br/><img src="./demi-droite.png" alt=""><br/>Quelle est l’abscisse du point B ?<br/>`,
            options: ["2,2", "1,12", "22", "20,2"],
            correctAnswer: 0
          },
          {
            question: `Quelle fraction correspond au point A ?<br/><img src="./fraction.png" alt=""><br/>`,
            options: [`<span class="stacked-fraction"><div class="numerator">1</div><div class="denominator">4</div></span>`, `<span class="stacked-fraction"><div class="numerator">4</div><div class="denominator">1</div></span>`, `<span class="stacked-fraction"><div class="numerator">4</div><div class="denominator">10</div></span>`, `<span class="stacked-fraction"><div class="numerator">10</div><div class="denominator">4</div></span>`],
            correctAnswer: 2
          },
          {
            question: "Choisir le nombre encadré par 10 000 et 100 000 : 10 000 < ... < 100 000",
            options: ["9 345", "87 842", "235 412", "1 010 000"],
            correctAnswer: 1,
          },
          {
            question: "Quel nombre décimal peut s’intercaler entre les deux nombres suivants ?<br/>4,6 < ... < 4,8",
            options: ["4,81", "4,72", "4,59", "4,06"],
            correctAnswer: 1,
          },
          {
            question: `<img src="./barreaux.png" alt=""><br/>On a colorié les...`,
            options: ["3/4 de la figure", "3/7 de la figure", "4/4 de la figure", "4/7 de la figure"],
            correctAnswer: 1,
          },
          {
            question: "Choisir le nombre qui permet de compléter l’addition pour obtenir le résultat suivant.<br/>433 + ... = 440",
            options: ["5", "6", "7", "8"],
            correctAnswer: 2,
          },
          {
            question: "Quel nombre correspond à l’ordre de grandeur le plus proche du résultat de cette multiplication ?<br/>335 × 3 ≈ ...",
            options: ["10 000", "1 000", "100", "10"],
            correctAnswer: 1,
          },
          {
            question: "Calculer mentalement la multiplication suivante : 754,82 × 10 = ...",
            options: ["7,5482", "75,482", "7548,2", "75 482"],
            correctAnswer: 2,
          },
          {
            question: "Voici un calcul : 3,4 × 5 =<br/>Quel est le résultat de ce calcul ?",
            options: ["1,7", "15,2", "17", "152,0"],
            correctAnswer: 2,
          },
          {
            question: "Compléter avec l’unité qui convient. Une coccinelle peut mesurer 7...",
            options: ["mm", "cm", "m", "dm"],
            correctAnswer: 0,
          },
            {
              question: `Un rectangle est dessiné sur un quadrillage. Dans ce quadrillage, chaque carreau mesure 1 cm de côté. Quel est le périmètre, en centimètre, de ce rectangle ?<br/><img src="./rectangle.png" alt=""><br/>`,
              options: [
                "14 cm",
                "18 cm",
                "22 cm",
                "28 cm"
              ],
              correctAnswer: 2
            },
            {
              question: "Le professeur demande à un élève : « 1 m c’est combien de fois plus grand que 1 dm ? »",
              options: [
                "10 fois",
                "100 fois",
                "1 000 fois",
                "10 000 fois"
              ],
              correctAnswer: 0
            },
            {
              question: "Compléter l’égalité : 24 cm = ... mm",
              options: [
                "0,24",
                "2,4",
                "240",
                "2 400"
              ],
              correctAnswer: 2
            },
            {
              question: `Un carré est dessiné sur un quadrillage. Chaque carreau de ce quadrillage fait 1 cm de côté. Quelle est l’aire de ce carré en cm<sup>2</sup> ?<br/><img src="./carre.png" alt=""></br>`,
              options: [
                "6 cm<sup>2</sup>",
                "9 cm<sup>2</sup>",
                "12 cm<sup>2</sup>",
                "15 cm<sup>2</sup>"
              ],
              correctAnswer: 1
            },
            {
                question: `Le pavé droit ci-dessous est composé de petits cubes de 1 cm3. Quel est le volume de ce pavé droit ?<br/><img src="./pave.png" alt=""></br>`,
              options: [
                "4 cm<sup>3</sup>",
                "9 cm<sup>3</sup>",
                "20 cm<sup>3</sup>",
                "24 cm<sup>3</sup>"
              ],
              correctAnswer: 2
            },
            {
              question: `Louis a tracé deux angles <img src="./b.png" alt=""> et Ê. Il souhaite les comparer.<br/><img src="./angles.png" alt=""><br/>`,
              options: [
                  `Les angles&nbsp;<img src="./b.png" alt="">&nbsp;et Ê sont égaux.`,
                  `L’angle&nbsp;<img src="./b.png" alt="">&nbsp;est plus grand que l’angle Ê.`,
                  `L’angle&nbsp;<img src="./b.png" alt="">&nbsp;est plus petit que l’angle Ê.`,
                  "On ne peut pas savoir."
              ],
              correctAnswer: 0
            },
            {
              question: `Ce matin, Camille est à la gare et son train part dans 53 minutes. Elle regarde l’heure sur l’horloge du quai. À quelle heure va partir le train ?<br/><img src="./horloge.png" alt=""><br/>`,
              options: [
                "9h00",
                "8h22",
                "8h75",
                "9h15"
              ],
              correctAnswer: 3
            },
            {
              question: "Une balle de tennis de table pèse 2,7...",
              options: [
                "kilogrammes (kg)",
                "grammes (g)",
                "millimètres (mm)",
                "centilitres (cL)"
              ],
              correctAnswer: 1
            }
        ],
        francaisVocabulaire2023: [
            {
              question: "« Julie trouve ce plat succulent. Elle en a repris deux fois. » <br/>Dans cette phrase, « succulent » est le synonyme de...",
              options: [
                "délicieux",
                "indigeste",
                "répugnant",
                "écœurant"
              ],
              correctAnswer: 0
            },
            {
              question: "« futur, prochain, prévoir, bientôt » <br/>Ces mots appartiennent au thème de...",
              options: [
                "l'avenir",
                "la conjugaison",
                "la patience",
                "l'imprudence"
              ],
              correctAnswer: 0
            },
            {
              question: "« Il a mangé trop de chocolat, il n’est pas dans son assiette. » <br/>L’expression « ne pas être dans son assiette » signifie...",
              options: [
                "avoir tout mangé.",
                "adorer le chocolat.",
                "être un peu malade.",
                "manger dans le plat."
              ],
              correctAnswer: 2
            },
            {
              question: "« Cette pomme est très abimée mais reste mangeable. » <br/>L’utilisation du suffixe « -able » signifie que la pomme...",
              options: [
                "ne doit pas être mangée.",
                "peut être mangée.",
                "est mangée avec plaisir.",
                "est mangée à moitié."
              ],
              correctAnswer: 1
            },
            {
              question: "Chercher l’intrus dans la catégorie.",
              options: [
                "hamster",
                "cage",
                "oiseau",
                "tigre"
              ],
              correctAnswer: 1
            },
            {
              question: "Les mots suivants sont formés avec le préfixe mal- qui signifie « qui n'est pas », sauf un.<br/>Trouver l'intrus.",
              options: [
                "malade",
                "malheureux",
                "malhabile",
                "malchanceux"
              ],
              correctAnswer: 0
            },
            {
              question: "« Ce lieu était immense et contenait aussi bien des essais que des romans. Il aimait s'y rendre pour feuilleter divers ouvrages, découvrir des personnages, se passionner pour des intrigues. » Le lieu évoqué par ces phrases est...",
              options: [
                "une bibliothèque.",
                "un laboratoire.",
                "un musée.",
                "un théâtre."
              ],
              correctAnswer: 0
            },
            {
              question: "Les noms « chronologie », « chronomètre » ou encore l’adjectif « chronique » viennent du mot grec : chronos = le temps. <br/>Une maladie chronique est donc une maladie qui...",
              options: [
                "dure plusieurs années.",
                "est en train de guérir.",
                "fait beaucoup souffrir.",
                "est extrêmement répandue."
              ],
              correctAnswer: 0
            },
            {
              question: "Dans quelle phrase le verbe « donner » signifie-t-il « offrir, remettre » ?",
              options: [
                "Ma chambre donne sur le jardin.",
                "Louise donne son bonnet à Sarah.",
                "On donne une pièce de Molière ce soir.",
                "Je ne lui donne pas trente ans."
              ],
              correctAnswer: 1
            },
            {
              question: "« Sa mère est très permissive : elle lui laisse faire ce qu’il veut. » <br/>D’après cette phrase, « permissive » est de la même famille que...",
              options: [
                "permanent",
                "percevoir",
                "permettre",
                "perturbé"
              ],
              correctAnswer: 2
            },
            {
              question: "Les expressions suivantes appartiennent toutes au langage familier sauf une. Laquelle ?",
              options: [
                "Il s’en fiche.",
                "Il est trop fort.",
                "Il en a marre.",
                "Il a hâte d’arriver."
              ],
              correctAnswer: 3
            },
            {
              question: "« Marie n’a pas ... nécessaire de nous prévenir. »<br/>« Le délinquant va être ... en comparution immédiate. » Les deux phrases peuvent être complétées par le même mot.<br/>Choisir celui qui convient.",
              options: [
                "jugé",
                "convoqué",
                "estimé",
                "pensé"
              ],
              correctAnswer: 0
            },
            {
              question: "Associer chaque mot souligné à son contraire.",
              options: [
                ["enthousiasmant", "fragile", "audacieux", "peureux" ],
                ["courageux", "résistant", "ennuyeux", "craintif"]
              ],
              correctAnswer: [2, 1, 3, 0]
            },
            {
              question: "Choisir la signification de « peine » ou de l’expression formée avec « peine » dans chaque phrase.",
              options: [
                ["Il éprouve de la peine à parler.", "Ce que tu lui as dit lui a fait beaucoup de peine.", "Ils ont eu à peine le temps de finir.", "Elle peine à faire ses exercices."],
                ["Idée de chagrin", "Idée de difficulté", "Idée de justesse"]
              ],
              correctAnswer: [1, 0, 2, 1]
            },
            {
              question: "Le narrateur raconte l’arrivée d’un orage. <br/>« Je n’avais pas peur, mais je sentais une inquiétude étrange, une angoisse profonde, animale. [...] C’était un murmure lointain, une rumeur trop faible pour inquiéter les échos, mais frissonnante, continue, magique. » <br/>Marcel Pagnol, Le Château de ma mère, 1957. <br/>Les mots suivants évoquent une émotion.",
              options: [
                ["inquiétude", "angoisse", "rumeur", "frissonnante"],
                ["Vrai", "Faux"]
              ],
              correctAnswer: [0, 0, 1, 1]
            },
        ]
    },
    quatrieme: {
        mathsAutomatismes2023: [
                {
                  "question": "14 − 6 = ...",
                  "options": ["8", "6987", "14", "−6"],
                  "correctAnswer": 0
                },
                {
                  "question": "Combien vaut la moitié de 70 ?",
                  "options": ["45", "35", "40", "30"],
                  "correctAnswer": 1
                },
                {
                  "question": "Quelle fraction de la surface est coloriée ?<img src='./mathsAutomatismes4eme2023/camembert5.png' alt=''>",
                  "options": ["<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>5</div></span>", "<span class='stacked-fraction'><div class='numerator'>5</div><div class='denominator'>8</div></span>", `<span class="stacked-fraction"><div class="numerator">3</div><div class="denominator">8</div></span>`, `<span class="stacked-fraction"><div class="numerator">5</div><div class="denominator">3</div></span>`],
                  "correctAnswer": 1
                },
                {
                  "question": "168 + 18 = ...",
                  "options": ["190", "188", "176", "186"],
                  "correctAnswer": 3
                },
                {
                  "question": "− 5 + 7 = ...",
                  "options": ["2", "-12", "12", "-2"],
                  "correctAnswer": 0
                },
                {
                  "question": "Si l’on réduit l’expression 2n + 3n alors on obtient :",
                  "options": ["5n<sup>2</sup>", "6n<sup>2</sup>", "5n", "6n"],
                  "correctAnswer": 2
                },
                {
                  "question": "Max assiste à un spectacle qui dure 135 minutes. Comment cette durée peut-elle s’écrire autrement ?",
                  "options": ["1h 35min", "1h 15min", "2h 15min", "2h 35min"],
                  "correctAnswer": 2
                },
                {
                  "question": "12 × 7 + 12 × 3 = ...",
                  "options": ["120", "240", "36", "84"],
                  "correctAnswer": 0
                },
                {
                  "question": "La mesure de l’angle IJK est égale à ... <img src='./mathsAutomatismes4eme2023/triangle-angle.png' alt=''>",
                  "options": ["20°", "50°", "70°", "110°"],
                  "correctAnswer": 3
                },
                {
                  "question": "14 + <span class='stacked-fraction'><div class='numerator'>6</div><div class='denominator'>10</div></span> + <span class='stacked-fraction'><div class='numerator'>2</div><div class='denominator'>1000</div></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;= ...",
                  "options": ["1 462", "14,602", "14,62", "140,62"],
                  "correctAnswer": 1
                },
                {
                  "question": "Un cycliste roule pendant 30 min à la vitesse moyenne de 18 km/h.<br/><b>Quelle distance parcourt-il ?<b/>",
                  "options": ["18 km", "36 km", "5,4 km", "9 km"],
                  "correctAnswer": 3
                },
                {
                  "question": "Compléter par le nombre qui convient : 43 milliers = ... dizaines",
                  "options": ["4,3", "4300", "43", "430"],
                  "correctAnswer": 1
                },
                {
                  "question": "Dans quelle figure a-t-on colorié <span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>4</div></span> de la surface?",
                  "options": ["<img src='./mathsAutomatismes4eme2023/camembert7.png' alt=''>", "<img src='./mathsAutomatismes4eme2023/camembert6.png' alt=''>", "<img src='./mathsAutomatismes4eme2023/barreau4.png' alt=''>", "<img src='./mathsAutomatismes4eme2023/barreau3.png' alt=''>"],
                  "correctAnswer": 1
                },
                {
                  "question": "7 - (-5) = ...",
                  "options": ["12", "-12", "2", "-2"],
                  "correctAnswer": 0
                },
                {
                  "question": "Quel est l'abscisse du point A ?<img src='./mathsAutomatismes4eme2023/droite.png' alt=''>",
                  "options": ["0,3", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>4</div></span>", "<span class='stacked-fraction'><div class='numerator'>4</div><div class='denominator'>3</div></span>", "3"],
                  "correctAnswer": 1
                },
                {
                  "question": "0,3 s'écrit aussi ...",
                  "options": ["<span class='stacked-fraction'><div class='numerator'>1</div><div class='denominator'>3</div></span>", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>10</div></span>", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>100</div></span>", "<span class='stacked-fraction'><div class='numerator'>0</div><div class='denominator'>3</div></span>"],
                  "correctAnswer": 1
                },
                {
                  "question": "On donne l’expression A = 1 + 3x.<br/><b>Quelle est la valeur de A pour x = 8 ?<b/>",
                  "options": ["25", "32", "39", "48"],
                  "correctAnswer": 0
                },
                {
                  "question": "Compléter l’égalité. 75 L = ... cL",
                  "options": ["0,75", "7,5", "7500", "750"],
                  "correctAnswer": 2
                },
                {
                  "question": `Le tableau suivant est un tableau de proportionnalité :<br/><table align='center'border="1" cellspacing="0" cellpadding="5"><tr><th>12</th/><th>4<tr/><tr><th></th><th>9</th></tr><br/><b>Quel nombre doit-on placer dans la case vide ?<b/>`,
                  "options": ["27", "17", "30", "3"],
                  "correctAnswer": 0
                },
                {
                  "question": "On considère quatre points A, B, C et D dans le plan rapporté au repère ci-contre :<br/><img src='./mathsAutomatismes4eme2023/quadrillage.png' alt=''><br/><b>Quel point a pour coordonnées (3 ; 5) ?<b/>",
                  "options": ["le point A", "le point B", "le point C", "le point D"],
                  "correctAnswer": 3
                },
                {
                  "question": "On considère le triangle ABC représenté ci-dessous :<br/><img src='./mathsAutomatismes4eme2023/triangle-hauteur.png'><br/><b>Quel calcul donne son aire ?<b/>",
                  "options": ["&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14 x 12", `<span class="stacked-fraction"><div class="numerator">14&nbsp;x&nbsp;12</div><div class="denominator">2</div></span>`, `<span class="stacked-fraction"><div class="numerator">15&nbsp;x&nbsp;12</div><div class="denominator">2</div></span>`, "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13 x 14 x 15"],
                  "correctAnswer": 1
                },
                {
                  "question": "Quel encadrement de 56 par deux nombres entiers est correct ?",
                  "options": [`55 <&nbsp;&nbsp; <span class="stacked-fraction"><div class="numerator">56</div><div class="denominator">10</div></span>&nbsp;&nbsp; < 57`, `5 <&nbsp;&nbsp; <span class="stacked-fraction"><div class="numerator">56</div><div class="denominator">10</div></span>&nbsp;&nbsp; < 6`, `4 <&nbsp;&nbsp; <span class="stacked-fraction"><div class="numerator">56</div><div class="denominator">10</div></span>&nbsp;&nbsp; < 5`, `0 <&nbsp;&nbsp; <span class="stacked-fraction"><div class="numerator">56</div><div class="denominator">10</div></span>&nbsp;&nbsp; < 1`],
                  "correctAnswer": 1
                },
            ],
            mathsProblemes2023: [
                {
                  "question": "Dans un supermarché, les fraises sont à 2 € le kilogramme.<br/><b>Combien vais-je payer pour acheter 5 kg de fraises dans ce supermarché ?</b>",
                  "options": ["5 €", "6 €", "7 €", "10 €"],
                  "correctAnswer": 3
                },
                {
                  "question": "Le dessin ci-dessous représente le plan d’un terrain clos.<br/><img src='./mathsProblemes4eme2023/pentagone.png'><br/>On connaît la longueur de quatre des côtés du terrain. Le périmètre de ce terrain est de 210 m.<br/><b>Quelle est la longueur du cinquième côté ?</b>",
                  "options": ["210 m", "170 m", "40 m", "30 m"],
                  "correctAnswer": 2
                },
                {
                  "question": "César et Romain habitent à la même distance du collège. Romain vient au collège à pied. Sa vitesse est de 5 km/h. César vient à vélo. Il est trois fois plus rapide. Le trajet de Romain dure 12 minutes.<br/><b/>Combien dure le trajet de César ?</b>",
                  "options": ["36 min", "15 min", "4 min", "3 min"],
                  "correctAnswer": 2
                },
                {
                  "question": "Dans une même boulangerie, Lucas achète 7 pains au chocolat et paie 6,30 €, Enzo achète 9 pains au chocolat et paie 8,10 €.<br/><b>Combien paierait Camillia pour 8 pains au chocolat ?</b>",
                  "options": ["7,10 €", "7,20 €", "0,90 €", "7,30 €"],
                  "correctAnswer": 1
                },
                {
                  "question": "Louise a acheté 10 objets identiques pour 22 €.<br/><b>Combien coûteront 15 de ces objets ?</b>",
                  "options": ["47 €", "33 €", "15 €", "27 €"],
                  "correctAnswer": 1
                },
                {
                  "question": "Une randonnée cyclotouriste est organisée sur un parcours de 60 km. Un arrêt est prévu au tiers de ce parcours.<br/><b>Quelle est la distance parcourue avant cet arrêt ?</b>",
                  "options": ["10 km", "12 km", "15 km", "20 km"],
                  "correctAnswer": 3
                },
                {
                  "question": "Le plan de ce terrain indique une zone boisée.<br/><img src='./mathsProblemes4eme2023/foret.png'<br/><b>La superficie de la zone boisée est de</b>",
                  "options": ["9 km<sup>2</sup>", "36 km<sup>2</sup>", "60 km<sup>2</sup>", "4 km<sup>2</sup>"],
                  "correctAnswer": 0
                },
                {
                  "question": "Une boîte de macarons (biscuits fourrés) contient 3 macarons au café, 3 à la fraise, 6 au chocolat et 4 à la pomme. On prend un macaron les yeux fermés, sans avoir vu la boîte auparavant.<br/><b>On a 25 % de chances d’attraper un macaron...</b>",
                  "options": ["au café.", "au chocolat.", "à la fraise.", "à la pomme."],
                  "correctAnswer": 3
                },
                {
                  "question": "Anna marche 100 m pour faire le tour de son jardin rectangulaire. La longueur de ce jardin est de 30 m.<br/><b>Quelle est la largeur ?</b>",
                  "options": ["35 m", "20 m", "25 m", "40 m"],
                  "correctAnswer": 1
                },
                {
              "question": `Tom a mangé &nbsp; <span class="stacked-fraction"><div class="numerator">1</div><div class="denominator">2</div></span> gâteau. Jean a mangé &nbsp; <span class="stacked-fraction"><div class="numerator">1</div><div class="denominator">4</div></span> du même gâteau.<br/><b>À eux deux, quelle fraction du gâteau ont-ils mangée ?</b>`,
                  "options": [`<span class="stacked-fraction"><div class="numerator">2</div><div class="denominator">6</div></span>`, `<span class="stacked-fraction"><div class="numerator">2</div><div class="denominator">6</div></span>`, `<span class="stacked-fraction"><div class="numerator">2</div><div class="denominator">4</div></span>`, `<span class="stacked-fraction"><div class="numerator">3</div><div class="denominator">4</div></span>`],
                  "correctAnswer": 3
                },
                {
                  "question": "Avec 20 L de lait on obtient 1 kg de beurre.<br/><b>Pour obtenir 100 g de beurre il faut ... de lait?</b>",
                  "options": ["2000 L", "20 cL", "200 L", "2 L"],
                  "correctAnswer": 3
                },
                {
                  "question": "Quand Romain prend sa douche, il ouvre le robinet au maximum pendant 8 minutes et il utilise 80 litres d’eau.<br/>Quand il prend un bain, il ouvre le même robinet au maximum pendant 12 minutes.<br/><b>Quel volume d’eau économise-t-il en choisissant de prendre une douche à la place d’un bain ?</b>",
                  "options": ["160 L", "40 L", "10 L", "120 L"],
                  "correctAnswer": 1
                },
                {
                  "question": "On considère la figure suivante.<br/><img src='./mathsProblemes4eme2023/rouge.png' alt=''><br/><b>On souhaite exprimer l’aire de la surface hachurée en fonction de a et b.</b>",
                  "options": ["3(b − a)", "3(b + a)", "3a", "3b"],
                  "correctAnswer": 0
                },
                {
                  "question": "On veut carreler un salon de 56 m<sup>2</sup>.<br/>Ce salon a la forme d’un rectangle de longueur 8 m.<br/><b>Quelle est la largeur du salon ?</b>",
                  "options": ["64 m", "14 m", "7 m", "48 m"],
                  "correctAnswer": 2
                },
                {
                  "question": "Un ébéniste fabrique des figurines en bois.<br/>La réalisation complète d’une figurine nécessite 17 minutes.<br/>On lui demande de réaliser 11 figurines en trois heures.<br/><b>Est-ce possible s’il travaille sans interruption ?</b>",
                  "options": [
                    "OUI. Il pourra fabriquer douze figurines.",
                    "NON. Il pourra fabriquer seulement neuf figurines.",
                    "OUI. Il lui faudra moins de deux heures.",
                    "NON. Il lui manquera sept minutes."
                  ],
                  "correctAnswer": 3
                },
                {
                  "question": "Anna lit un livre de 110 pages.<br/>Chaque jour elle en lit 10 %.<br/><b>Combien lit-elle de pages en 7 jours ?</b>",
                  "options": ["70 pages", "77 pages", "10 pages", "11 pages"],
                  "correctAnswer": 1
                },
                {
                  "question": "Il faut 80 g de fleurs de crocus pour obtenir 1 g de safran.<br/><b>Quelle masse de safran un producteur pourra-t-il produire avec 1 kg de fleurs de crocus ?</b>",
                  "options": ["80 g", "12,5 kg", "12,5 g", "80 kg"],
                  "correctAnswer": 2
                },
                {
                  "question": "Dans une fratrie de 5 enfants, un seul est gaucher et les autres sont droitiers.<br/><b>Quel est le pourcentage d’enfants droitiers dans cette fratrie ?</b>",
                  "options": ["80 %", "75 %", "4 %", "20 %"],
                  "correctAnswer": 0
                },
                {
                  "question": "Voici la composition de l'œuf.<br/><img src='./mathsProblemes4eme2023/oeuf.png' alt=''><br/>En moyenne, un œuf pèse 60 g.<br/><b>Lequel des tableaux ci-dessous est correct ?</b>",
                  "options": [
                    "<img src='./mathsProblemes4eme2023/tableau1.png'>",
                    "<img src='./mathsProblemes4eme2023/tableau2.png'>",
                    "<img src='./mathsProblemes4eme2023/tableau3.png'>",
                    "<img src='./mathsProblemes4eme2023/tableau4.png'>"
                  ],
                  "correctAnswer": 0
                },
            ],
            francaisComprehension2023: [
                  {
                    "question": "Choisir le titre qui convient le mieux.",
                    "options": [
                      "Entrée en fonction d’un jeune maitre d’étude",
                      "Journée de rentrée au collège de Sarlande",
                      "Première nuit dans une petite ville des Cévennes",
                      "Arrivée du nouveau principal du collège"
                    ],
                    "correctAnswer": 0
                  },
                  {
                    "question": "Sarlande se trouve dans les...",
                    "options": ["Cévennes.", "Alpes.", "Vosges.", "Pyrénées."],
                    "correctAnswer": 0
                  },
                  {
                    "question": "Le collège de Sarlande est...",
                    "options": [[
                      "vivant.",
                      "ancien.",
                      "grand.",
                      "lumineux."],[
                      "Vrai", "Faux"
                    ]],
                    "correctAnswer": [1, 0, 0, 1]
                  },
                  {
                    "question": "Page 2: « [...], et je pus examiner à mon aise sa petite face pâlotte et sèche, éclairée par deux yeux froids, sans couleur. »<br/>Le narrateur parle...</br>",
                    "options": [
                      "du portier de l’internat.",
                      "du principal du collège.",
                      "du surveillant général.",
                      "du maitre d’étude."
                    ],
                    "correctAnswer": 1
                  },
                  {
                    "question": "« Je restai debout au milieu de la pièce, en tortillant mon chapeau entre mes doigts. » (page 2)<br/>Durant l’entretien avec le principal, le narrateur est...",
                    "options": ["rêveur.", "confiant.", "angoissé.", "amusé."],
                    "correctAnswer": 2
                  },
                {
                  "question": "Le principal va embaucher le narrateur car il a été convaincu par...",
                  "options": [
                    "la tenue qu’il porte.",
                    "son jeune âge.",
                    "la lettre qu’il remet.",
                    "sa personnalité."
                  ],
                  "correctAnswer": 2
                },
                {
                    "question": "« Le principal prit la lettre, la lut, la relut, la plia, la déplia, la relut encore, puis il finit par me dire que, grâce à la recommandation toute particulière du recteur et l’honorabilité de ma famille, il consentait à me prendre chez lui, bien que ma grande jeunesse lui fît peur.»<br/>La lettre d'introduction...",
                    "options": [[
                        "met en avant la jeunesse du narrateur.",
                        "présente les origines familiales du narrateur.",
                        "critique le manque d'assurance du narrateur.",
                        "présente le narrateur de manière positive"
                    ], ["Vrai", "Faux"]],
                    "correctAnswer": [1, 0, 1, 0]
                },
                  {
                    "question": "« mais les clés n’étaient pas bienveillantes, elles. Il fallait les entendre s’agiter et grincer avec frénésie :<br/>« <u>Si tu bouges, petit drôle, gare à toi !</u>»»<br/>Les paroles soulignées sont...",
                    "options": [
                      "dites par le surveillant lui-même.",
                      "pensées par le principal.",
                      "prononcées réellement par les clés.",
                      "imaginées par le narrateur."
                    ],
                    "correctAnswer": 3
                  },
                {
                  "question": "Aux yeux du narrateur, l’atmosphère générale qui se dégage du collège est...",
                  "options": [
                    "fantastique",
                    "familière",
                    "accueillante",
                    "angoissante"
                  ],
                  "correctAnswer": 3
                },
                  {
                    "question": "Le nom de famille du narrateur est...",
                    "options": ["Eyssette.", "Serrières.", "Viot.", "Cassagne."],
                    "correctAnswer": 0
                  },
                  {
                    "question": "D’après le document 1, de nos jours, en France, on gaspille ... de nourriture par an et par personne.",
                    "options": ["8 kg", "20 kg", "150 kg", "5,5 millions de kg"],
                    "correctAnswer": 2
                  },
                  {
                    "question": "Selon le document 1, depuis 2018, la loi Garot impose aux restaurateurs de...",
                    "options": [
                      "proposer des assiettes moins garnies.",
                      "trier systématiquement leurs déchets.",
                      "permettre aux clients d’emporter leurs restes.",
                      "resservir les aliments non consommés."
                    ],
                    "correctAnswer": 2
                  },
                {
                  "question": "Les points d’exclamation utilisés par le journaliste dans le document 2 expriment ...",
                  "options": [
                    "sa colère",
                    "sa déception",
                    "son pessimisme",
                    "son enthousiasme"
                  ],
                  "correctAnswer": 3
                },
                {
                  "question": "Document 2. « Ça vous semble dérisoire ? Et bien détrompez-vous. »<br/>Le journaliste s’adresse...",
                  "options": [
                    "aux habitants de Saint-Jean de la Ruelle.",
                    "à ses lecteurs peu convaincus.",
                    "aux élèves du collège Max Jacob.",
                    "à l’experte Hanane Boutayeb."
                  ],
                  "correctAnswer": 1
                },
                {
                  "question": "Dans le document 2, le journaliste parle d’une « portion de fromage »...<br/>",
                  "options": [
                    "parce que les jeunes doivent consommer plus de produits laitiers.",
                    "pour exprimer son désaccord avec le contenu des menus de cantine.",
                    "pour donner un exemple concret de troc dans la cantine du collège.",
                    "parce que le fromage est l'aliment le plus gaspillé dans les cantines"
                  ],
                  "correctAnswer": 2
                },
                  {
                    "question": "D’après le document 3 (page 5), on peut réduire le gaspillage alimentaire à la maison en...",
                    "options": [[
                      "achetant des surgelés.",
					  "triant les déchets.",
                      "réduisant les portions.",
                      "cuisinant les restes."
                    ], ["Vrai", "Faux"]],
                    "correctAnswer": [1, 1, 0, 0]
                  },
                {
                  "question": "Selon les étapes du gaspillage présentées dans le document 3 (page 5), on peut observer les premiers gaspillages dans...",
                  "options": [
                    "les supermarchés.",
                    "les maisons.",
                    "les champs.",
                    "les usines."
                  ],
                  "correctAnswer": 2
                },
                {
                  "question": "D’après ces documents, lutter contre le gaspillage alimentaire c’est une question qui concerne...",
                  "options": [
                    "vraiment tout le monde.",
                    "d’abord les industriels.",
                    "surtout les agriculteurs.",
                    "seulement les enfants."
                  ],
                  "correctAnswer": 0
                },
                {
                    "question": "Chacun des documents a un objectif principal différent.<br/>Indiquer pour chaque objectif le document correspondant.",
                    "options": [[
                        "Promouvoir la politique générale menée contre le gaspillage alimentaire",
                        "Illustrer la lutte contre le gaspillage alimentaire par une mise en oeuvre concrète",
                        "Faire prendre conscience de l'ampleur et des mécanismes du gaspillage alimentaire"
                    ], ["Document 1", "Document 2", "Document 3"]],
                    "correctAnswer": [0, 1, 2]
                }
            ],
            francaisLexique2023: [
              {
                "question": "Trouver un mot de la même famille que : « espérance, désespérer, espérer ».",
                "options": ["esprit", "espoir", "espace", "espèce"],
                "correctAnswer": 1
              },
              {
                "question": "jardin<u>age</u> - arros<u>age</u> - gomm<u>age</u> - démont<u>age</u><br/>Le suffixe souligné permet de former un mot qui indique...",
                "options": ["un contraire.", "un métier.", "une action.", "une matière."],
                "correctAnswer": 2
              },
              {
                "question": "Voici des mots de la même famille. Trouver l’intrus.",
                "options": ["engranger", "arranger", "déranger", "ranger"],
                "correctAnswer": 0
              },
              {
                "question": "Le verbe « charger » accepte plusieurs préfixes. Trouver l’intrus.",
                "options": ["sur-", "in-", "dé-", "re-"],
                "correctAnswer": 1
              },
              {
                "question": "Les mots suivants sont formés avec le suffixe « -ette » qui signifie « petite », sauf pour un d’entre eux. Trouver l’intrus.",
                "options": ["maisonnette", "poulette", "chouette", "jupette"],
                "correctAnswer": 2
              },
              {
                "question": "Indiquer si les mots proposés sont de la même famille ou non.",
                "options": [["« carapace » et « car »", "« dénouer » et « nœud »", "« joyeux » et « joie »"], ["Sont de la même famille.", "Ne sont pas de la même famille."]],
                "correctAnswer": [1, 0, 0]
              },
              {
                "question": "Si l’ « hypotension » signifie qu’on a une tension artérielle inférieure à la normale.<br/>Si un « thermomètre » est un instrument qui sert à mesurer les températures.<br/>Que signifie donc « être en hypothermie » ?",
                "options": ["Que la tension est inférieure à la normale.", "Que la température est inférieure à la normale.", "Que la température est supérieure à la normale.", "Que le thermomètre est plus petit que la normale."],
                "correctAnswer": 1
              },
              {
                  "question": "« gouverner, autorité, président, reine ».<br/>Ces mots appartiennent au thème...",
                  "options": ["du conte.", "du pouvoir.", "de la beauté.", "de la richesse."],
                  "correctAnswer": 1
              },
              {
                "question": "« Mon père est crédule : je lui ai dit que j’avais eu 20/20 en endurance et il a pensé que c’était vrai ! »<br/>D’après cette phrase, « crédule » est de la même famille que...",
                "options": ["craindre.", "croire.", "cruel.", "crudité."],
                "correctAnswer": 1
              },
              {
                "question": "Tous les mots ci-dessous ont un sens proche sauf un. Lequel ?",
                "options": ["vaillance", "hardiesse", "témérité", "traitrise"],
                "correctAnswer": 3
              },
              {
                "question": "« J'ai sans cesse cette sensation affreuse d'un danger menaçant, cette appréghension d'un malheur qui vient ou de la mort qui approche, ce pressentiment qui est sans doute l'atteinte d'un mal encore inconnu. » <i>Le Horla</i>, Maupassant<br/>Dans cet extrait, celui qui dit « je » semble:",
                "options": ["égaré.", "menaçant.", "anxieux.", "serein."],
                "correctAnswer": 2
              },
              {
                "question": "Trouver le mot qui appartient au thème de la mer.",
                "options": ["mercure", "marin", "maternité", "mérite"],
                "correctAnswer": 1
              },
              {
                "question": "Indiquer pour chaque adjectif s’il donne une image positive ou négative de l’attitude d’une personne.",
                "options": [["prétentieux", "modeste", "orgueilleux", "humble"], ["Image positive", "Image négative"]],
                "correctAnswer": [1, 0, 1, 0]
              },
              {
                "question": "Dans les quatre phrases ci-dessous, le mot souligné a une signification différente. Associer chaque phrase à la signification qui convient.",
                "options": [["Mattéo a pris des <u>notes</u> en regardant la vidéo.", "Emma a obtenu la <u>note</u> de 15/20 en mathématiques.", "Cette musique commence par la <u>note</u> fa.", "Paolo a payé sa <u>note</u> d’hôtel en partant."], ["Facture", "Trace écrite", "Nom d'un son", "Résultat"]],
                "correctAnswer": [1, 3, 2, 0]
              },
              {
                "question": "Dans la phrase : « Ce musicien <u>fait</u> d’admirables symphonies. », remplacer « fait » par le verbe qui convient.",
                "options": ["compose", "fonde", "négocie", "agence"],
                "correctAnswer": 0
              }
          ],
        },
	seconde: {
        mathsAutomatismes2023: [
                {
                  "question": "10<sup><sup>-3</sup></sup> = ...",
                  "options": ["-10<sup><sup>3</sup></sup>", "-30", "0,001", "0,003"],
                  "correctAnswer": 2
                },
                {
                  "question": "<img src='./mathsAutomatismes2nde2023/fraction1.png' alt=''>",
                  "options": ["1", "<span class='stacked-fraction'><div class='numerator'>1</div><div class='denominator'>4</div></span>", "<span class='stacked-fraction'><div class='numerator'>2</div><div class='denominator'>4</div></span>", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>4</div></span>"],
                  "correctAnswer": 1
                },
				{
                  "question": "<img src='./mathsAutomatismes2nde2023/fraction2.png' alt=''>",
                  "options": ["<span class='stacked-fraction'><div class='numerator'>4</div><div class='denominator'>15</div></span>", "<span class='stacked-fraction'><div class='numerator'>6</div><div class='denominator'>10</div></span>", "<span class='stacked-fraction'><div class='numerator'>8</div><div class='denominator'>25</div></span>", "<span class='stacked-fraction'><div class='numerator'>60</div><div class='denominator'>15</div></span>"],
                  "correctAnswer": 0
                },				
                {
                  "question": "Voici une expression algébrique: -5 + 2x.<br/>Quelle est la valeur de cette expression pour x = 8?",
                  "options": ["-5 + 28", "-5 + 8<sup><sup>2</sup></sup>", "-5 + 2&times;8", "-5 + 2&divide;8"],
                  "correctAnswer": 2
                },
				{
                  "question": "Quelle est la forme développée du produit 3(5x+1)?",
                  "options": ["18x", "15x + 1", "15x + 3", "35x + 1"],
                  "correctAnswer": 2
                },
                {
                  "question": "Quelle est la bonne explication pour la résolution de l'équation -2x = 1",
                  "options": ["Pour obtenir la solution, j'ajoute 2 aux deux membres de l'égalité.", "Pour obtenir la solution, je divise les deux membres de l'égalité par -2.", "Pour obtenir la solution, je divise les deux membres de l'égalité par +2.", "Pour obtenir la solution, je multiplie les deux membres de l'égalité par -2."],
                  "correctAnswer": 1
                },
                {
                  "question": "10<sup><sup>5</sup></sup>&times;10<sup><sup>3</sup></sup>",
                  "options": ["100<sup><sup>15</sup></sup>", "100<sup><sup>8</sup></sup>", "10<sup><sup>15</sup></sup>", "10<sup><sup>8</sup></sup>"],
                  "correctAnswer": 3
                },
				{
                  "question": "<img src='./mathsAutomatismes2nde2023/fraction3.png' alt=''>",
                  "options": ["<span class='stacked-fraction'><div class='numerator'>7</div><div class='denominator'>15</div></span>", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>2</div></span>", "<span class='stacked-fraction'><div class='numerator'>3</div><div class='denominator'>8</div></span>", "<span class='stacked-fraction'><div class='numerator'>1</div><div class='denominator'>5</div></span>"],
                  "correctAnswer": 0
                },		
                {
                  "question": "On considère un nombre relatif x tel que -x est strictement positif.",
                  "options": ["x est négatif", "x est positif", "x est égal à 0", "On ne peut rien dire sur le signe de x"],
                  "correctAnswer": 0
                },
                {
                  "question": "Si on réduit l'expression 2n<sup><sup>2</sup></sup> + 3n<sup><sup>2</sup></sup> + 4n + 5 alors on obtient",
                  "options": ["14n<sup><sup>2</sup></sup>", "5n<sup><sup>2</sup></sup> + 4n + 5", "9n<sup><sup>2</sup></sup> + 5", "28n"],
                  "correctAnswer": 1
                },
                {
                  "question": "Un manteau coûte 140€. Le magasin propose une réduction de 20% sur cet article. Quel calcul peut-on faire pour trouver le montant de la réduction?",
                  "options": ["140&times;0,2", "<img src='./mathsAutomatismes2nde2023/fraction4.png' alt=''>", "140&divide;20", "<img src='./mathsAutomatismes2nde2023/fraction5.png' alt=''>"],
                  "correctAnswer": 0
                },
                {
                  "question": "On donne le tableau suivant:<br/><img src='./mathsAutomatismes2nde2023/tableau1.png' alt=''><br />Quel nombre doit-on placer dans la case vide pour que ce tableau soit un tableau de proportionnalité ?",
                  "options": ["4", "6,25", "13", "16"],
                  "correctAnswer": 3
                },
                {
                  "question": "Sur la figure suivante, le premier rectangle a pour longueur 9 cm et pour largeur 3 cm. Le deuxième rectangle est une réduction du premier rectangle et a pour largeur 2 cm.<br /><img src='./mathsAutomatismes2nde2023/figure1.png' alt=''><br />Quelle est la longueur (en cm) du deuxième rectangle ?",
                  "options": ["6", "7", "8", "13,5"],
                  "correctAnswer": 0
                },
                {
                  "question": "Voici une série de valeurs:<br />20 ; 0 ; 9 ; 10 ; 17 ; 14 ; 0<br />La moyenne de cette série est 10. Quelle est la justification correcte parmi les propositions suivantes:",
                  "options": ["La moyenne est 10 car c’est la moitié de 20.", "La moyenne est 10 car il y a dans la série autant de valeurs inférieures à 10 que de valeurs supérieures à 10.", "La moyenne est 10 car la valeur 10 est au milieu de la série.", "La moyenne est 10 car (20 + 0 + 9 + 10 + 17 + 14 + 0)&divide;7 = 10"],
                  "correctAnswer": 3
                },
                {
                  "question": "Voici la répartition des communications effectuées par des lycéens avec leur téléphone portable<br  /><img src='./mathsAutomatismes2nde2023/figure2.png' alt=''><br />Quelle proportion des communications effctuées, les communications audio représentent-elles?",
                  "options": ["90%", "45%", "25%", "20%"],
                  "correctAnswer": 2
                },
				 {
                    "question": "On donne la figure suivante:<br /><img src='./mathsAutomatismes2nde2023/figure3.png' alt=''><br />Pour chaque ligne du tableau, cocher la réponse correcte.",
                    "options": [[
                        "d1 et d5 semblent...",
                        "d2 et d3 semblent...",
                        "d4 et d5 semblent...",
						"d3 et d4 semblent..."
                    ], ["parallèles", "sécantes mais non perpendiculaires", "perpendiculaires"]],
                    "correctAnswer": [2, 0, 1, 1]
                },                
                {
                  "question": "La droite (d1) modélise l'évolution du coût total d'un voyage scolaire en fonction du nombre de participants:<br /><img src='./mathsAutomatismes2nde2023/figure4.png' alt=''><br />Si le coût total du voyage est de 6500€, quel est le nombre de participants?",
                  "options": ["42", "40", "46", "44"],
                  "correctAnswer": 0
                },
                {
                  "question": "On donne la figure ci-dessous:<br /><img src='./mathsAutomatismes2nde2023/figure5.png' alt=''><br />Pour montrer que le triangle est rectangle en G, il faut utiliser:",
                  "options": ["La réciproque du théorème de Thalès", "La réciproque du théorème de Pythagore", "Le théorème de Thalès", "Le théorème de Pythagore"],
                  "correctAnswer": 1
                },
            	{
                  "question": "On considère un parallélépipède rectangle dans l'espace rapporté à un repère:<br /><img src='./mathsAutomatismes2nde2023/figure6.png' alt=''><br />Les coordonnées du point B sont (0;5;3)<br />Les coordonnées du point D sont (2;5;0)<br />Quelles sont les coordonnées du point C?",
                  "options": ["(5;2;3)", "(2;5;3)", "(2;0;3)", "(0;4;1)"],
                  "correctAnswer": 1
                },
               
            ],
		    francaisComprehension12023: [
                {
                  "question": " Dans ce texte, l’auteur veut amener le lecteur à…",
                  "options": ["rire en lisant des histoires farfelues", "découvrir les bienfaits du futur.", "critiquer les conditions de vie des futurs robots.", "réfléchir sur le développement de la robotique."],
                  "correctAnswer": 3
                },
                {
                  "question": "Dans ce texte, le robot se nomme…",
                  "options": ["Donovan.", "Powell.", "Descartes.", "Cutie."],
                  "correctAnswer": 3
                },
				{
                  "question": "Le créateur de Cutie est un…",
                  "options": ["dieu.", "animal.", "robot.", "humain."],
                  "correctAnswer": 3
                },				
                {
                  "question": "Choisir la proposition qui correspond au résumé du texte.",
                  "options": ["Deux techniciens, Donovan et Powell, réalisent des tests psychologiques sur un robot nommé Cutie.", "Un robot remet en cause l’idée que ses maitres peuvent l’avoir conçu.", "Un robot, écœuré par ses conditions de travail, devient le meneur de la première grève robotique.", " Cutie, un robot devenu fou, décide de faire du mal à ses concepteurs Donovan et Powell."],
                  "correctAnswer": 1
                },
				{
                  "question": "D’après le début du texte, Cutie est un robot…",
                  "options": ["grand.", "mince.", "lourd.", "petit."],
                  "correctAnswer": 2
                },
                {
                  "question": "Dès le début du texte, Donovan…",
                   "options": [[
                        "est agacé d’entendre les paroles du robot.",
                        "est très content de voir le robot.",
                        "coupe la parole au robot.",
						"propose au robot de s’asseoir"
                    ], ["Vrai", "Faux"]],
                    "correctAnswer": [0, 1, 0, 1]
                },
                {
                  "question": "Au début du texte, Powell est « mal à l’aise » lors de l’arrivée du robot car…",
                  "options": ["la seule chaise libre est cassée.", "il est très occupé.", "la demande du robot est inhabituelle.", "il a très peur du robot."],
                  "correctAnswer": 2
                },
				{
                  "question": " La prise de conscience chez le robot a été provoquée par…",
                  "options": ["un bug informatique.", "une discussion avec un autre robot.", "une réflexion personnelle.", "la découverte d’un secret. "],
                  "correctAnswer": 2
                },		
                {
                  "question": "« Une hypothèse est étayée par la raison ou n’a aucune valeur. » Cutie veut dire que…",
                  "options": ["faire une hypothèse, c’est toujours dire la vérité.", "le raisonnement des humains est supérieur à celui des robots.", " pour être validée, une supposition doit être argumentée.", "tous les arguments se valent donc tout le monde peut avoir raison."],
                  "correctAnswer": 2
                },
                {
                  "question": "« Regardez-vous, dit-il enfin. Je m’en voudrais de vous dénigrer, mais regardez-vous. » Cette phrase montre que Cutie se sent...",
                  "options": ["supérieur", "égal", "inférieur", "indifférent"],
                  "correctAnswer": 0
                },
                {
                  "question": " Indiquer l’ordre des évènements dans le texte en cochant le numéro qui convient.",
                   "options": [[
                        "Powell accepte d’écouter le robot.",
                        "Le robot expose son raisonnement.",
                        "Le robot refuse de croire les humains.",
						"Donovan menace de détruire le robot."
                    ], ["1er évènement", "2ème évènement","3ème évènement", "4ème évènement"]],
                    "correctAnswer": [0, 1, 3, 2]
                },
                             
            ],
			francaisComprehension22023: [
                {
                  "question": " Choisir le titre correspondant à cet extrait.",
                  "options": [" Un renversement des rôles", "La fin d’une belle amitié", "Une île totalement inhabitée", "Un équipage enfin retrouvé"],
                  "correctAnswer": 0
                },
                {
                  "question": "Les personnages sont sur une île. Dans cette île,…",
                  "options": ["les esclaves et les maitres vivent en paix.", "les esclaves peuvent vivre cent ans.", " d’anciens esclaves maltraitent des maîtres.", "il n’y a plus d’esclave ni de maître."],
                  "correctAnswer": 2
                },
				{
                  "question": "Arlequin a gardé avec lui…",
                  "options": ["un gourdin", "une bouteille.", "une rame.", "un sac."],
                  "correctAnswer": 1
                },				
                {
                  "question": "Iphicrate prononce des paroles aimables comme « je t’en prie » ou « mon cher Arlequin » car il…",
                  "options": ["veut être proche de son valet.", "est particulièrement bien élevé.", "est privé de son pouvoir de maître.", "se montre de bonne humeur."],
                  "correctAnswer": 2
                },
				{
                  "question": "« Les marques de votre amitié tombent toujours sur mes épaules », dit Arlequin. Il veut dire qu’Iphicrate est…",
                  "options": ["respecté", "sympathique.", "maladroit.", "violent."],
                  "correctAnswer": 3
                },
                {
                  "question": "Iphicrate reproche à Arlequin d’être un esclave…",
                  "options": ["incapable.", "menteur.", "fainéant.", "insolent."],
                  "correctAnswer": 3
                },
				{
                  "question": "« IPHICRATE, (à part les premiers mots) : Le coquin abuse de ma situation : j’ai mal fait de lui dire où nous sommes, Arlequin, ta gaité ne vient pas à propos ; marchons de ce côté. »<br />Dans cette réplique, Iphicrate parle pour lui-même jusqu’à…",
                  "options": ["propos", "sommes", "abuse", "situation"],
                  "correctAnswer": 1
                },		
                {
                  "question": "Arlequin dit le contraire de ce qu’il pense dans une des phrases suivantes. Laquelle ?",
                  "options": ["« Mon cher patron, vos compliments me charment. »", "« Car je ne t’obéis plus, prends-y garde. »", "« Tu me traitais comme un pauvre animal. » ", "« On dit qu’ils ne font rien aux esclaves comme moi. »"],
                  "correctAnswer": 0
                },
				{
                  "question": " Choisir la suite immédiate logique de cet extrait.",
                  "options": ["Iphicrate part se cacher.", " Arlequin regagne la chaloupe.", "Iphicrate explore le cœur de l’ile.", "Arlequin s’allie avec Iphicrate."],
                  "correctAnswer": 0
                },	
				{
                  "question": "D’après la lecture de cet extrait, on peut penser que la pièce de théâtre « L’Ile des esclaves » a été écrite pour…",
                  "options": ["faire réfléchir aux rapports de pouvoir entre les hommes. ", "mettre en scène les effets traumatisants d’un naufrage. ", "raconter une amitié entre des hommes différents.", " dénoncer l’attitude cruelle des habitants d’une île."],
                  "correctAnswer": 0
                },	
                {
                  "question": " Iphicrate ne cesse d’évoluer dans cette scène. Indiquer l’ordre d’apparition de ses attitudes.",
                   "options": [[
                        "Il s’étonne du comportement d’Arlequin.",
                        "Il maudit Arlequin.",
                        "Il donne des ordres à Arlequin.",
						"Il flatte Arlequin."
                    ], ["1ère attitude", "2ème attitude","3ème attitude", "4ème attitude"]],
                    "correctAnswer": [1, 3, 0, 2]
                },
                             
            ],
        },
}
